<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Death_In_the_12th_House-4.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-5"><a href="#/OEBPS/Death_In_the_12th_House3#Contents-A">Dedication</a></p>
<p class="body-center"><em class="italic">For music and astrology<br class="calibre3"/>The two great loves of my life<br class="calibre3"/>Forever in harmony</em></p>
<p class="body-center"><em class="italic">And for Goldie<br class="calibre3"/>Constant in an ever changing universe</em></p>
<p class="body-center"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Death_In_the_12th_House-4.vue?dc7d774c